module.exports = __webpack_public_path__ + "static/media/question-button.37429386.svg";